import { useParams } from 'react-router-dom'
import EditMessageForm from './EditMessageForm'

import { useGetMessagesQuery } from './messageApiSlice'
import { useGetGroupsQuery } from '../groups/groupsApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import { useGetUsersQuery } from '../users/usersApiSlice'
const EditMessage = () => {
    useTitle('geshtop-Exercise: Edit Message')

    const { messageId, groupId } = useParams()
    const { username, isTeacher, isAdmin } = useAuth()

    const { message } = useGetMessagesQuery("messagesList", {
        selectFromResult: ({ data }) => ({
            message: data?.entities[messageId]
        }),
    })
    const { groups } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            groups: data?.ids.map(id => data?.entities[id])
        }),
    })
    const { users } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            users: data?.ids.map(id => data?.entities[id])
        }),
    })
    if (!message || !groups || !users) return <PulseLoader color={"#FFF"} />
    const filterUsers = groupId==="0" ? [...users] : users.filter(user=>user.groups.includes(groupId))

    // if (!isTeacher && !isAdmin) {
    //     if (message.username !== username) {
    //         return <p className="errmsg">No access</p>
    //     }
    // }

    const content =
    <>
    <EditMessageForm message={message} usersList={filterUsers}  groups={groups} />  
       
    </>

    return content
}
export default EditMessage